import React from "react";
import * as Icon from "react-icons/md";
import { MaisDiv } from "./styled";

export default function Mais() {
  const onButtonClick = () => {
    // using Java Script method to get PDF file
    fetch("Tutorial_Sistema_de_Passageiros.pdf").then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "Tutorial_Sistema_de_Passageiros.pdf";
        alink.click();
      });
    });
  };
  return (
    <MaisDiv>
      <center>
        <h1>Mais informações sobre o sistema de passageiros</h1>
      </center>
      <div className="row">
        <h3>Baixar guia de utilização do sistema</h3>
        <Icon.MdGetApp className="icon" onClick={onButtonClick} />
      </div>
    </MaisDiv>
  );
}
